import { OriginConfigMap, StageSpecificVariables } from '../interfaces/app.config.interface';
import { originSpecific } from './origin-specific.config';

export class AppEnvironmentConfiguration {
	public static getConfig(): StageSpecificVariables {
		const host = AppEnvironmentConfiguration.getHost();
		const found = originSpecific.find((conf: OriginConfigMap) => !!conf.origins.find(origin => origin.includes(host)));
		return AppEnvironmentConfiguration.getResponse(found);
	}

	private static getResponse(hostConfig: OriginConfigMap) {
		if (hostConfig) {
			return hostConfig.config;
		} else {
			return AppEnvironmentConfiguration.getDefault();
		}
	}

	private static getHost(): string {
		return window.location.host;
	}

	private static getDefault(): StageSpecificVariables {
		return originSpecific[0].config;
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
